

























import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import AxLogo from '@/assets/ax_logo.svg';
const components = { AxLogo };

@Component({ components })
export default class extends Mixins(AxPage) {}
